<div class="col-12">
  <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
    <strong class="lblCls">
      Deal is on?
    </strong>
    <kendo-switch [(ngModel)]="switchDealToggle" [onLabel]="'Yes'" [offLabel]="'No'"
                  (valueChange)="handleDealSwitchToggle($event)"
                  class="activeSwitchCls">
    </kendo-switch>
  </div>
</div>
<br />

<section>
  <kendo-grid [data]="itemGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="itemGridstate.sort"
              (sortChange)="finishSampleGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="itemGridstate.take"
              [skip]="itemGridstate.skip"
              [columnMenu]="false"
              (pageChange)="finishSampleGridPageChange($event)"
              (dataStateChange)="finishSampleDataStateChange($event)"
              [filter]="itemGridstate.filter"
              [loading]="finishSampleLoading"
              id="sample-product-admin-grid">

    <kendo-grid-column field="longItemNumber" title="{{finishSampleLbl.longItemNumber}}" [headerClass]="'wrapheader-sample-admin-grid'"
                       [width]="160" [columnMenu]="false" [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="sample-grid-category-div">
          <span>{{dataItem.longItemNumber}}</span>
        </div>
      </ng-template>

      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="description" title="{{finishSampleLbl.description}}"
                       [headerClass]="'wrapheader-sample-admin-grid'" [width]="180" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="availableLocName" title="{{finishSampleLbl.location}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="80" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="currentInventory" title="{{finishSampleLbl.avlQty}}" [width]="90" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.currentInventory}}</span>
        <ng-template #noListItemStock>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="basePrice" title="{{finishSampleLbl.basePrice}}" [width]="80" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.basePrice|currency}}</span>
        <ng-template #noListItemCost>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="cost" title="{{finishSampleLbl.cost}}" [width]="80" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.cost|currency}}</span>
        <ng-template #noListItemCost>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="discount" title="{{finishSampleLbl.discount}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="90" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.discount|number}}%</span>
        <ng-template #noListItemInventory>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column field="salePrice" title="{{finishSampleLbl.salePrice}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="90" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <a role="button" (click)="processPriceHistoryGridData(dataItem)"><span>{{dataItem.salePrice|currency}}</span></a>
        <ng-template #noListItemReorder>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="{{finishSampleLbl.isActive}}" field="isActive" [width]="90" filter="boolean">
      <kendo-grid-messages filterIsTrue="Yes"
                           filterIsFalse="No">
      </kendo-grid-messages>
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'" [disabled]="true"
                      [offLabel]="'No'">
        </kendo-switch>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="{{finishSampleLbl.action}}" [width]="100" field="">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton class="clearKendoButton btn btn-success btnSizeCls btn-sample-admin-grid-edit"
                (click)="openEditItemDialog(dataItem)">
          <span class=" k-icon k-i-edit k-i-pencil"></span>
        </button> &nbsp;
        <button class="k-button k-grid-remove-command btn-sample-admin-grid-edit" (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash">
          </span>
        </button>

      </ng-template>
    </kendo-grid-command-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
  </kendo-grid>
  <!--Sample Product Fullfilment-->
  <div class="col-12">
    <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
      <button (click)="importDialogOpen()" class=" m-3 btn k-button" kendoButton [icon]="'file-bac'">
        Import
      </button>
      <button (click)="openAddItemDialog()" class="m-3 btn btn-success" kendoButton>
        Add Item
      </button>
    </div>

  </div>

</section>

<!--Sample Product Fullfilment-->
<section class="dialogSection">
  <kendo-dialog [title]="sampleSubCategoryTitleText" *ngIf="finishSampleDialog.opened" (close)="closeItemUpdateDialog()">
    <form [formGroup]="finishSampleForm" style="max-height: 450px">

      <div class="row">
        <input type="hidden" formControlName="itemId" />
        <div class="col-sm-12">
          <div class="form-group">
            <label class="lblCls">
              Long Item #<span class="requiredField"></span>
            </label>
            <input type="text" kendoTextBox formControlName="longItemNumber"
                   class="kendoInput disabled-input"
                   disabled />
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.shortItemNumber}}<span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox formControlName="itemNumber" class="kendoInput"
                   [ngClass]="{'borderRed':finishSampleLbl.isEmptyItemNumber && finishSampleLbl.isSubmitted}" (blur)="validateDiscountItemForm()" />
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.description}}<span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox formControlName="description" class="kendoInput"
                   [ngClass]="{'borderRed':finishSampleLbl.isEmptyDescription && finishSampleLbl.isSubmitted}"
                   (blur)="validateDiscountItemForm()" />
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.finishCode}}
            </label>
            <input type="text" kendoTextBox formControlName="finishCode"
                   class="kendoInput" (blur)="validateDiscountItemForm()" />
          </div>

          <div class="form-group">
            <label class="lblCls" style="margin-right:20px;">
              {{finishSampleLbl.size}}
            </label>
            <input type="text" kendoTextBox formControlName="size"
                   class="kendoInput" />

          </div>

          <div class="form-group">
            <label class="lblCls" style="margin-right:20px;">
              {{finishSampleLbl.paintCode}}
            </label>
            <input type="text" kendoTextBox formControlName="paintCode"
                   class="kendoInput" [ngClass]="{'borderRed':finishSampleLbl.isEmptyPaintCode && finishSampleLbl.isSubmitted}" />
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.location}}<span class="requiredField">*</span>
            </label>

            <kendo-dropdownlist formControlName="location" [ngModel]="{value:lid,name:lname}"
                                [data]="locationList"
                                textField="name" valueField="value"
                                class="kendoInput"
                                [ngClass]="{'borderRed':finishSampleLbl.isEmptyLocation && finishSampleLbl.isSubmitted}"
                                (blur)="validateDiscountItemForm()">
            </kendo-dropdownlist>
          </div>

          <div class="form-group grid-dimension-container">
            <div>
              <label class="lblCls" for="foo">{{finishSampleLbl.basePrice}}</label>
              <input type="number" kendoTextBox formControlName="basePrice"
                     class="kendoInput" [disabled]="isEditDisabled" />
            </div>
            <div>
              <label class="lblCls" for="foo">{{finishSampleLbl.discount}}</label>
              <input type="number" kendoTextBox formControlName="discount"
                     class="kendoInput" [disabled]="isEditDisabled" />
            </div>
            <div>
              <label class="lblCls" for="foo">{{finishSampleLbl.salePrice}}</label>
              <input type="number" kendoTextBox formControlName="salePrice"
                     class="kendoInput" [disabled]="isEditDisabled" />
            </div>
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.avlQty}}
            </label><br />
            <input type="text" kendoTextBox formControlName="currentInventory" class="kendoInput" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.createdDate}}
            </label><br />
            <input type="text" kendoTextBox formControlName="createdDate" disabled class="kendoInput" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.isActive}}
            </label>
            <kendo-switch formControlName="isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="activeSwitchCls">
            </kendo-switch>
          </div>
          <br />

          <div>
            <ng-container *ngIf="itemDocExistsList.includes(finishSampleForm.controls.itemId.value); else noDoc">
              <span class="k-icon k-i-check" style="color:green; margin-right: 4px"></span>
              <span>Document exists!</span>
              <button kendoButton class="btn-danger" (click)="deleteMergedDoc(finishSampleForm.controls.itemId.value)">Delete</button>
            </ng-container>

            <ng-template #noDoc>
              <span>No documents uploaded yet!</span>
            </ng-template>
          </div>

          <br />
          <div class="form-group">
            <label for="pdfUpload" class="selectFilesLabel">Select Documents to Upload </label>
            <input id="pdfUpload" type="file" (change)="onFilesSelected($event)" accept=".pdf" style="display: none" multiple  />

            <ul *ngIf="selectedFiles.length > 0">
              <li *ngFor="let file of selectedFiles; let i = index">
                {{ file.name }}
                <button type="button" (click)="removeFile(i)">Remove</button>
              </li>
            </ul>

            <button (click)="uploadFiles()" [disabled]="selectedFiles.length === 0 || documentUploadInProgress" class=" m-3 btn k-button dialogBtnSize">Upload</button>

            <p style="color:red" *ngIf="documentUploadErrorMessage">{{ documentUploadErrorMessage}}</p>
            <p style="color:green" *ngIf="documentUploadSuccessMessage">{{ documentUploadSuccessMessage }}</p>
          </div>

        </div>

      </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="subCategorySaveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="closeItemUpdateDialog()">
                Close
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="subCategorySaveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="saveItem()">
                Save<kendo-loader *ngIf="subCategorySaveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>

<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    Are you sure you want to remove this item from Discount Store
    <b> : {{ gridItemToRemove.longItemNumber }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="Confirm?" *ngIf="showDealFlagWarningMessage" (close)="closeDealToggleConfirmationBox()">
  <p style="margin: 30px; text-align: center;" *ngIf="switchDealToggle">
    This will show Discount store for all user. Are you sure you want to proceed?
  </p>
  <p style="margin: 30px; text-align: center;" *ngIf="!switchDealToggle">
    This will hide Discount store for all user. Are you sure you want to proceed?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="closeDealToggleConfirmationBox()">
      No
    </button>
    <button class='k-button k-primary' (click)="proceedToUpdateDealFlag(true)" primary="true">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>


<section class="dialogSection">
  <kendo-dialog title="Price History" *ngIf="isPriceHistory" (close)="closePriceHistory()">
    <br />
    <kendo-grid [data]="priceHistoryGridView"
                [height]="470"
                [pageSize]="priceHistoryState.take"
                [skip]="priceHistoryState.skip"
                [sortable]="true"
                [pageable]="true"
                [loading]="finishSampleLoading"
                id="item-price-history-grid">
      <kendo-grid-column field="createdDate" title="Date"
                         [width]="160" [columnMenu]="false" [filterable]="false" [editable]="false">
      </kendo-grid-column>
      <kendo-grid-column field="salePrice" title="Price"
                         [width]="160" [columnMenu]="false" [filterable]="false" [editable]="false">
      </kendo-grid-column>
    </kendo-grid>
  </kendo-dialog>
</section>
